import { render, staticRenderFns } from "./TabBootcamps.vue?vue&type=template&id=2b8f492f"
import script from "./TabBootcamps.vue?vue&type=script&lang=js"
export * from "./TabBootcamps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports